import { cn } from "@/lib/utils";

/**
 * MyAiFriend's product mark: a soft four-way signal around one connection
 * point. It reads as an AI spark without borrowing a letter or a familiar
 * infinity symbol.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 48 48"
      className={cn("shrink-0 drop-shadow-[0_10px_24px_rgba(216,255,114,0.16)]", className)}
      role="img"
      aria-label="Логотип MyAiFriend"
    >
      <rect width="48" height="48" rx="15" className="fill-brand-lime" />
      <path
        d="M24 6.5c1.5 10 7.5 16 17.5 17.5-10 1.5-16 7.5-17.5 17.5C22.5 31.5 16.5 25.5 6.5 24c10-1.5 16-7.5 17.5-17.5Z"
        className="fill-brand-forest"
      />
      <circle cx="24" cy="24" r="5" className="fill-brand-lime" />
      <circle cx="24" cy="24" r="2.6" className="fill-brand-coral" />
    </svg>
  );
}
